export default "__VITE_ASSET__DEF2$BBM__"